import { useTranslation } from "react-i18next";
import { Alert, Button } from "@/components/ui";
import { getApiErrorMessage } from "@/lib/errorMessages";
import type { QueryLoadFailure } from "@/lib/queryLoadFailure";

/** Inline load error for a picker or option list, with a retry button. */
export function QueryLoadError({
  failure,
  className,
}: {
  failure: QueryLoadFailure;
  className?: string;
}) {
  const { t } = useTranslation("common");
  return (
    <Alert
      variant="error"
      role="alert"
      title={failure.title}
      className={className}
      action={
        <Button variant="ghost" size="sm" onClick={failure.onRetry}>
          {t("tryAgain")}
        </Button>
      }
    >
      {getApiErrorMessage(failure.error)}
    </Alert>
  );
}
